import { spItemKeyFacet } from '../Keys';
import ISPGetItemResponse from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/interfaces/ISPGetItemResponse';
import { IItemCacheThunkAction, IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { ItemResolver } from '@ms/items-view/lib/private/models/items/ItemResolver';
import SimpleUri from '@ms/odsp-utilities/lib/uri/SimpleUri';
import { getFolderName } from './getFolderName';
import {
  displayNameFacet,
  parentFolderItemFacet,
  fileSizeFacet,
  folderFacet
} from '@ms/items-view/lib/private/facets/ItemFacets';
import { folderPathFacet } from '../Facets';
import { getCurrentRootFolder } from '../../utilities/path/getCurrentRootFolder';

/**
 * @internal
 */
export function getParentItemKey(key: typeof spItemKeyFacet.type): typeof spItemKeyFacet.type | undefined {
  const {
    webAbsoluteUrl,
    listFullUrl,
    rootFolder
  } = key;

  if (rootFolder) {
    const currentRootFolder = getCurrentRootFolder(listFullUrl, rootFolder);
    if (currentRootFolder !== undefined) {
      return {
        webAbsoluteUrl: webAbsoluteUrl,
        listFullUrl: listFullUrl,
        itemId: '',
        rootFolder: currentRootFolder
      };
    }
  }

  return undefined;
}

/**
 * @internal
 */
export function getAllAncestorItems(payload: {
  parentKey: typeof spItemKeyFacet.type;
  serverData: ISPGetItemResponse;
}): IItemCacheThunkAction<{
  itemResolver: ItemResolver;
}> {
  const {
    parentKey,
    serverData
  } = payload;

  return (dispatch: IItemCacheDispatch) => {
    let parentItemKey: typeof spItemKeyFacet.type | undefined = parentKey;
    const listServerRelativePath = new SimpleUri(parentKey.listFullUrl).path; // get server relative url.
    const itemResolver = new ItemResolver();

    while (parentItemKey) {
      const folderName = dispatch(getFolderName({ key: parentItemKey, serverData: serverData }));
      const folderPath = parentItemKey.rootFolder || listServerRelativePath;
      const newParentItemKey = getParentItemKey(parentItemKey);

      itemResolver.resolveItems({
        items: {
          [spItemKeyFacet.serialize(parentItemKey)]: {
            ...folderFacet.pack({}),
            ...(folderPath !== undefined ? folderPathFacet.pack(folderPath) : {}),
            ...(folderName ? displayNameFacet.pack(folderName) : {}),
            ...(newParentItemKey ? parentFolderItemFacet.pack({
              itemKey: spItemKeyFacet.serialize(newParentItemKey)
            }) : {}),
            ...fileSizeFacet.pack(undefined)
          }
        }
      });

      parentItemKey = newParentItemKey;
    }

    return {
      itemResolver
    };
  };
}
